import React from "react";

const VARIANTS = {
  primary:
    "bg-gradient-to-r from-amber-400 to-orange-500 text-slate-950 shadow-lg shadow-orange-500/20 hover:-translate-y-0.5 hover:shadow-xl",

  secondary:
    "border border-slate-200 bg-white text-slate-700 shadow-sm hover:-translate-y-0.5 hover:border-orange-300 hover:text-orange-600 dark:border-white/10 dark:bg-white/5 dark:text-slate-200",

  dark:
    "bg-slate-950 text-white shadow-lg hover:-translate-y-0.5 hover:bg-slate-800 dark:bg-white dark:text-slate-950",
};

export default function CateButton({
  children,
  icon: Icon,
  variant = "primary",
  type = "button",
  className = "",
  disabled = false,
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={[
        "inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl px-5 text-sm font-black transition duration-200 focus:outline-none focus:ring-4 focus:ring-orange-400/20 disabled:pointer-events-none disabled:opacity-50",
        VARIANTS[variant] ||
          VARIANTS.primary,
        className,
      ].join(" ")}
      {...props}
    >
      {Icon ? (
        <Icon aria-hidden="true" />
      ) : null}

      {children}
    </button>
  );
}